import type { StepProps } from "../types";
import { Field, Input } from "@/components/ui";

export default function Step3NextOfKin({ context, draft, updateField }: StepProps) {
  const emp = context.employee;

  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
      <div className="md:col-span-2">
        <Field label="Next of kin name *">
          <Input
            type="text"
            value={draft.next_of_kin_name ?? emp?.next_of_kin_name ?? ""}
            onChange={e => updateField("next_of_kin_name", e.target.value)}
          />
        </Field>
      </div>

      <Field label="Next of kin phone *">
        <Input
          type="tel"
          inputMode="numeric"
          value={draft.next_of_kin_phone ?? emp?.next_of_kin_phone ?? ""}
          onChange={e => updateField("next_of_kin_phone", e.target.value)}
        />
      </Field>

      <Field label="Next of kin relationship *" hint="e.g. Spouse Parent Sibling">
        <Input
          type="text"
          placeholder="Spouse"
          value={draft.next_of_kin_relationship ?? emp?.next_of_kin_relationship ?? ""}
          onChange={e => updateField("next_of_kin_relationship", e.target.value)}
        />
      </Field>
    </div>
  );
}
